<template>
  <!-- 明细列表 -->
  <el-dialog :title="title" :visible="visible" :show-close="false">
    <el-alert
      title="这里只显示可优惠的单据，没有显示已优惠或已返现的单据"
      type="error"
      :closable="false">
    </el-alert>
    <br/>
    <el-table
      :data="list"
      stripe
      border
      style="width:100%"
      :row-class-name="tableRowClassName"
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection">
      </el-table-column>
      <el-table-column
        prop="company_name"
        label="所属科目"
        width="100">
      </el-table-column>
      <el-table-column
        prop="bill_no"
        label="单据编号"
        width="120">
      </el-table-column>
      <el-table-column
        prop="fee"
        label="应收金额"
        width="80">
      </el-table-column>
      <el-table-column
        prop="student_count"
        label="学员人数"
        width="80">
      </el-table-column>
      <el-table-column
        label="可优惠金额"
        width="100">
        <template slot-scope="scope">
          {{ scope.row.fee / scope.row.student_count >= minDisFee ? Math.round(scope.row.student_count * 12.5) : 0 }}
        </template>
      </el-table-column>
      <el-table-column
        prop="pay_total"
        label="实收金额"
        width="80">
      </el-table-column>
      <el-table-column
        label="优惠后实收"
        width="100">
        <template slot-scope="scope">
          {{ scope.row.pay_total - (scope.row.fee / scope.row.student_count >= minDisFee ? Math.round(scope.row.student_count * 12.5) : 0) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="start_time"
        label="开始时间"
        width="160">
      </el-table-column>
      <el-table-column
        prop="end_time"
        label="结束时间"
        width="160">
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        width="150">
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="pageSizeChange"
      @current-change="pageChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total"
      :total="total">
    </el-pagination>
    <div slot="footer" class="dialog-footer">
      <span style="font-size:14px;color:green;">已选择{{ selectRows.length }}张单据,优惠合计{{ discountMoney }}元&nbsp;&nbsp;</span>
      <el-button type="primary" @click="commit" :loading="commiting">确定优惠{{ discountMoney }}元</el-button>
      <el-button @click="close">关闭窗口</el-button>
    </div>
  </el-dialog>
</template>

<script>
import qs from 'qs'
import _ from 'lodash'
export default {
  props: {
    coach: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    title: {
      type: String,
      default: '请选择要优惠的单据'
    }
  },
  data () {
    return {
      list: [],
      loading: false,
      currentPage: 1,
      pageSize: 0,
      total: 0,
      commiting: false,
      selectRows: [],
      minDisFee: 300
    }
  },
  computed: {
    discountMoney () {
      let t = 0
      for (let i = 0; i < this.selectRows.length; i++) {
        t += (this.selectRows[i].fee / this.selectRows[i].student_count >= this.minDisFee ? Math.round(this.selectRows[i].student_count * 12.5) : 0)
      }
      return t
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.fetchList()
      }
    }
  },
  methods: {
    fetchList () {
      this.loading = true
      this.$http.get('/dbapi/bill_list', {
        params: {
          coach_id: this.coach.coach_id,
          status: '正常',
          return_status: '未返现',
          fee_discount: 0
        },
        paramsSerializer: function(params) {
          return qs.stringify(params, { arrayFormat: 'repeat' })
        }
      }).then(response => {
        if (response.data.success) {
          this.list = response.data.list
          this.total = response.data.total
        } else {
          this.$message({
            type: 'error',
            message: response.data.message
          })
        }
      })
    },
    handleSelectionChange (val) {
      this.selectRows = val
    },
    pageChange (val) {
      this.currentPage = val
      this.fetchList()
    },
    pageSizeChange (val) {
      this.pageSize = val
      this.fetchList()
    },
    close () {
      this.$emit('close')
    },
    tableRowClassName ({row, rowIndex}) {
      if (row.status === '作废' || row.status === '退款' || row.pay_status === '未支付') {
        return 'row-red'
      } else if (row.return_status === '已返现') {
        return 'row-green'
      } else {
        return ''
      }
    },
    commit: _.throttle(
      function () {
        if (this.selectRows.length === 0) {
          return this.$message({
            type: 'error',
            message: '请选择要优惠的单据'
          })
        }
        this.commiting = true
        let ids = this.selectRows.filter(r => r.fee / r.student_count >= this.minDisFee).map(r => r.id)
        this.$http.post('/dbapi/discount_cash', {
          ids: ids,
          rate: this.coach.discount_rate
        }).then(response => {
          this.commiting = false
          if (response.data.success) {
            this.fetchList()
            this.$message({
              type: 'success',
              message: '操作成功'
            })
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      },
      2000
    )
  }
}
</script>



// WEBPACK FOOTER //
// src/components/return/DiscountDialog.vue